/**
 * Client-side JavaScript: Artifact utilities
 *
 * Provides formatBytes utility used by other report modules.
 */

export const JS_ARTIFACTS = `
  /* ── Artifact Utilities ── */
  function formatBytes(bytes){
    if(bytes===0)return '0 B';
    var k=1024;var sizes=['B','KB','MB','GB'];
    var i=Math.floor(Math.log(bytes)/Math.log(k));
    if(i>=sizes.length)i=sizes.length-1;
    return parseFloat((bytes/Math.pow(k,i)).toFixed(1))+' '+sizes[i];
  }
`;
